var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCloudDownload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.00004 14.6667L9.66671 13.3334M8.00004 14.6667V8.66675V14.6667ZM8.00004 14.6667L6.33337 13.3334L8.00004 14.6667Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.35606 6.07788C2.72553 6.23654 2.17464 6.61999 1.80689 7.15617C1.43914 7.69236 1.27984 8.34438 1.35893 8.98974C1.43801 9.63509 1.75003 10.2294 2.23637 10.6609C2.7227 11.0924 3.34988 11.3315 4.00006 11.3332H4.66672",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5534 4.75864C10.3255 3.85636 9.76312 3.07447 8.98015 2.57148C8.19718 2.06849 7.25225 1.88204 6.3369 2.04991C5.42156 2.21779 4.60429 2.72743 4.05077 3.47553C3.49726 4.22364 3.24891 5.15422 3.35607 6.07864C3.35607 6.07864 3.45807 6.66664 3.66673 6.99997",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.3334 11.3334C11.8041 11.3331 12.2694 11.2331 12.6987 11.04C13.1279 10.8469 13.5114 10.5651 13.8239 10.2131C14.1364 9.86107 14.3708 9.44688 14.5117 8.99777C14.6526 8.54865 14.6967 8.07479 14.6413 7.60738C14.5858 7.13996 14.432 6.68959 14.1899 6.28591C13.9479 5.88222 13.6231 5.53438 13.2369 5.26527C12.8507 4.99616 12.4119 4.81189 11.9494 4.72459C11.4869 4.63728 11.0111 4.64893 10.5534 4.75875L9.66675 5.00008",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloudDownload);
export default __webpack_public_path__ + "static/media/cloud-download.8aeec105fa9baba5015409ade0db1a8c.svg";
export { ForwardRef as ReactComponent };